// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3CKGy","label":"Category_label__3JB7q","content":"Category_content__1lukz","header":"Category_header__28EmJ","location":"Category_location__1XkTe"};